import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { TRABADJU_INFO as T } from '@/utils/businessInfo';
import { ArrowLeft, Briefcase, Users, Target, Heart } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function Sobre() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-gray-50 py-10" data-testid="page-sobre">
      <div className="max-w-4xl mx-auto px-4">
        <Link to="/"><Button variant="ghost" className="mb-4"><ArrowLeft className="h-4 w-4 mr-2" />{t('sobre.back')}</Button></Link>

        <article className="bg-white rounded-xl shadow-sm p-8">
          <h1 className="text-4xl font-bold mb-4">{t('sobre.title')}</h1>
          <p className="text-lg text-gray-600 mb-8">{t('sobre.subtitle')}</p>

          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-3">{t('sobre.missionTitle')}</h2>
            <p className="text-gray-700 leading-relaxed">
              {t('sobre.missionBody')}
            </p>
          </section>

          <section className="grid md:grid-cols-2 gap-6 mb-10">
            <div className="border border-gray-200 rounded-lg p-5">
              <Users className="h-8 w-8 text-blue-600 mb-3" />
              <h3 className="font-semibold text-lg mb-1">{t('sobre.cardCandidatesTitle')}</h3>
              <p className="text-gray-600 text-sm">{t('sobre.cardCandidatesBody')}</p>
            </div>
            <div className="border border-gray-200 rounded-lg p-5">
              <Briefcase className="h-8 w-8 text-indigo-600 mb-3" />
              <h3 className="font-semibold text-lg mb-1">{t('sobre.cardEmployersTitle')}</h3>
              <p className="text-gray-600 text-sm">{t('sobre.cardEmployersBody')}</p>
            </div>
            <div className="border border-gray-200 rounded-lg p-5">
              <Target className="h-8 w-8 text-purple-600 mb-3" />
              <h3 className="font-semibold text-lg mb-1">{t('sobre.cardCVTitle')}</h3>
              <p className="text-gray-600 text-sm">{t('sobre.cardCVBody')}</p>
            </div>
            <div className="border border-gray-200 rounded-lg p-5">
              <Heart className="h-8 w-8 text-rose-600 mb-3" />
              <h3 className="font-semibold text-lg mb-1">{t('sobre.cardCareTitle')}</h3>
              <p className="text-gray-600 text-sm">{t('sobre.cardCareBody')}</p>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-3">{t('sobre.whoTitle')}</h2>
            <p className="text-gray-700 leading-relaxed">
              {t('sobre.whoBody', { legalName: T.legal_name, nif: T.nif, address: T.address })}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-3">{t('sobre.contactsTitle')}</h2>
            <ul className="text-gray-700 space-y-1">
              <li>{t('sobre.email')}: <a href={`mailto:${T.email_public}`} className="text-blue-600 hover:underline">{T.email_public}</a></li>
              <li>{t('sobre.site')}: <a href={T.website} className="text-blue-600 hover:underline">{T.website}</a></li>
              <li>{t('sobre.address')}: {T.address}</li>
            </ul>
          </section>
        </article>
      </div>
    </div>
  );
}
